import { useEffect, useState } from 'react';
import { deliveryKeys } from 'common/constants/settings';
import TabSwitcher from 'components/molecules/TabSwitcher';
import { InputDescription, InputTitle } from 'components/atoms/styleds';
import SetupSettings from 'components/molecules/settings/v2/SetupSettings';

import routeCodes from 'common/constants/route-codes';
import { CreateLink } from 'components/molecules/user/MenuItem/styled';
import { InputWrapper } from 'components/atoms/styleds';

import { ContentWrapper, Divider } from './styled';
import { HeaderTitle } from '../SettingsForm/styled';
import RouterHelper from 'services/RouterHelper';
import { useUser } from 'redux/user/use-user';

const ServicesContent = ({
  data = {},
  activeTabKey,
  onChangeTab,
  currentRestaurant,
  hideSwitcher = false,
  hideTitle = false,
  hideCreateService = false,
  text,
}) => {
  const { isSuperAdmin } = useUser();
  const showServiceConfig = true;
  const showCreateService = activeTabKey === deliveryKeys.reservation;
  // const showCreateService = true;
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    const selected = [];
    ['table_reservation', 'takeaway', 'delivery'].forEach((i) => {
      if (data[i]) {
        selected.push(i);
      }
    });
    setSelectedValues(selected);
  }, [data]);

  const tabItems = [
    {
      id: deliveryKeys.reservation,
      label: 'Prenotazione tavoli',
      to: isSuperAdmin
        ? RouterHelper.getRouteWithRestaurant(routeCodes.superAdmin.settings)
        : routeCodes.settings,
      name: 'table_reservation',
    },
    {
      id: deliveryKeys.delivery,
      label: 'Delivery',
      to: isSuperAdmin
        ? RouterHelper.getRouteWithRestaurant(
            routeCodes.superAdmin.settingsConfigsDelivery,
          )
        : routeCodes.settingsConfigsDelivery,
      name: 'delivery',
    },
  ];

  return (
    <ContentWrapper style={{ paddingTop: 0 }}>
      {!!showServiceConfig && (
        <>
          <InputWrapper standardWidth={true}>
            {!hideTitle && (
              <HeaderTitle
                style={{ left: 0, paddingBottom: 30, bottom: 0 }}
                pos='relative'
              >
                Configura i servizi
              </HeaderTitle>
            )}
            {!hideSwitcher && (
              <TabSwitcher
                activeKey={activeTabKey}
                onClick={onChangeTab}
                items={tabItems}
                isLink={true}
                maxW='315px'
              />
            )}
            {showCreateService && (
              <>
                <InputTitle mt={30} mb={12}>
                  Crea servizi per fascie orarie
                </InputTitle>
                <InputDescription>
                  {!!text ? (
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                  ) : (
                    'Qui puoi creare e modificare i servizi dedicati alla prenotazione tavoli in base alle fasce orarie che desideri.'
                  )}
                </InputDescription>
                {!hideCreateService && (
                  <CreateLink
                    to={
                      isSuperAdmin
                        ? RouterHelper.getRouteWithRestaurant(
                            routeCodes.superAdmin.settingsConfigsServicesCreate,
                          )
                        : routeCodes.settingsConfigsServicesCreate
                    }
                  >
                    + Crea servizio
                  </CreateLink>
                )}
              </>
            )}
          </InputWrapper>
        </>
      )}
    </ContentWrapper>
  );
};

export default ServicesContent;
